import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import "../../../assets/css/customer/screens/deals/DealsDetailPage.css";
import AppContext from "../../../context/AppContext";
import MyNavbar from "../../../components/customer/myNavbar/MyNavbar";
import Footer from "../../../components/customer/footer/Footer";

function getCountdown(targetDate) {
  const diff = new Date(targetDate) - new Date();

  if (diff <= 0) {
    return { days: 0, hours: 0, mins: 0 };
  }

  return {
    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
    mins: Math.floor((diff / (1000 * 60) % 60)),
  };
}

export default function DealDetailPage() {

  const navigate = useNavigate();

  const {baseUrlForFile,selectedDealFromLandingPage} = useContext(AppContext);
  const [countdown, setCountdown] = useState(getCountdown(selectedDealFromLandingPage?.expiryDate));

  useEffect(() => {

    console.log(selectedDealFromLandingPage);

    const timer = setInterval(() => {
      setCountdown(
        getCountdown(selectedDealFromLandingPage?.expiryDate)
      );
    }, 60000);

    return () => clearInterval(timer);

  }, [selectedDealFromLandingPage]);

  if (!selectedDealFromLandingPage) {
    return (
      <>
      <MyNavbar/>
      <div>
        <p>Deal not found.</p>

        <button onClick={() => navigate("/deals")}>
          ← Back to Deals
        </button>
      </div>
      <Footer/>
      </>
    );
  }

  return (
<>
<MyNavbar/>
    <div className="deal-detail__page">

      <div className="deal-detail__main">

        {/* HERO */}
        <div className="deal-detail__hero">

          <div className="deal-detail__hero-left">

            {selectedDealFromLandingPage?.tag && (
              <span className="deal-detail__badge">
                {selectedDealFromLandingPage?.tag}
              </span>
            )}

            <div className="deal-detail__discount-big">
              {selectedDealFromLandingPage?.discount}
            </div>

            <h1 className="deal-detail__hero-title">
              {selectedDealFromLandingPage?.title}
            </h1>

            <p className="deal-detail__hero-desc">
              {selectedDealFromLandingPage?.description}
            </p>

          </div>

          <div className="deal-detail__hero-right">

            <div className="deal-detail__price-box">

              <div className="deal-detail__original-price">
                {selectedDealFromLandingPage?.originalPrice}
              </div>

              <div className="deal-detail__final-price">
                {selectedDealFromLandingPage?.finalPrice}
              </div>

              <div className="deal-detail__price-label">
                {selectedDealFromLandingPage?.session}
              </div>

            </div>

            <button className="deal-detail__claim-btn">
              Claim this Deal →
            </button>

          </div>

        </div>

        {/* EXPIRY */}
        {/* <div className="deal-detail__expiry-strip">

          <div className="deal-detail__expiry-left">

            <span className="deal-detail__expiry-icon">⏳</span>

            <div>
              <div className="deal-detail__expiry-label">
                Deal expires on
              </div>

              <div className="deal-detail__expiry-date">
                {selectedDealFromLandingPage?.expiryDate}
              </div>
            </div>

          </div>

          <div className="deal-detail__countdown">

            <div className="deal-detail__countdown-box">
              <span className="deal-detail__countdown-num">
                {countdown.days}
              </span>
              <span className="deal-detail__countdown-unit">
                DAYS
              </span>
            </div>

            <div className="deal-detail__countdown-box">
              <span className="deal-detail__countdown-num">
                {countdown.hours}
              </span>
              <span className="deal-detail__countdown-unit">
                HRS
              </span>
            </div>

            <div className="deal-detail__countdown-box">
              <span className="deal-detail__countdown-num">
                {countdown.mins}
              </span>
              <span className="deal-detail__countdown-unit">
                MINS
              </span>
            </div>

          </div>

        </div> */}

        {/* CONTENT */}
        <div className="deal-detail__columns">

          <div style={{
            display: "flex",
            flexDirection: "column",
            gap: "24px"
          }}>

            <div className="deal-detail__card">

              <div className="deal-detail__card-title">
                DESCRIPTION
              </div>

              <p>
                {selectedDealFromLandingPage?.description}
              </p>

            </div>

          </div>

          {/* SIDEBAR */}
          <div className="deal-detail__sidebar">

            <div className="deal-detail__book-card">

              <div className="deal-detail__book-price-row">

                <div className="deal-detail__book-original">
                  {selectedDealFromLandingPage?.originalPrice}
                </div>

                <div className="deal-detail__book-final">
                  {selectedDealFromLandingPage?.finalPrice}
                </div>

                <div className="deal-detail__book-session">
                  {selectedDealFromLandingPage?.session}
                </div>

              </div>

              <button className="deal-detail__book-btn">
                Book Appointment
              </button>

            </div>

          </div>

        </div>

      </div>

      {/* FOOTER */}
      <div className="deal-detail__footer-wrap">

        <div className="deal-detail__footer-card">

          <h2 className="deal-detail__footer-title">
            Book your skin consultation
            <br />
            today
          </h2>

          <p className="deal-detail__footer-sub">
            A 30-minute consultation with our dermatologists.
          </p>

          <button className="deal-detail__footer-btn">
            Book Appointment
          </button>

        </div>

      </div>

    </div>
    <Footer/>
    </>
  );
}